import { TierRateByYear } from '../../interfaces';

export const rates: TierRateByYear = {
    2018: [
        { to: 20_142, percentage: 0, base: 2_265, offset: 0 },
        { to: 68_507, percentage: -4.683, base: 2_265, offset: -20_142 },
      ],
    2019: [
        { to: 20_384, percentage: 0, base: 2_477, offset: 0 },
        { to: 68_507, percentage: -5.147, base: 2_477, offset: -20_384 },
      ],
    2020: [
      { to: 20_711, percentage: 0, base: 2_711, offset: 0 },
      { to: 68_507, percentage: -5.672, base: 2_711, offset: -20_711 },
    ],
    2021: [
      { to: 21_043, percentage: 0, base: 2_837, offset: 0 },
      { to: 68_507, percentage: -5.977, base: 2_837, offset: -21_043 },
    ],
    2022: [
      { to: 21_317, percentage: 0, base: 2_888, offset: 0 },
      { to: 69_398, percentage: -6.007, base: 2_888, offset: -21_317 },
    ],
    2023: [
      { to: 22_660, percentage: 0, base: 3_070, offset: 0 },
      { to: 73_031, percentage: -6.095, base: 3_070, offset: -22_660 },
    ],
    2024: [
      { to: 24_812, percentage: 0, base: 3_362, offset: 0 },
      { to: 75_518, percentage: -6.63, base: 3_362, offset: -24_812 },
    ],
};
